/** As Google Autocomplete Widget element has a closed ShadowRoot, we need to be creative to be able to add our own styling */
const attachShadow = Element.prototype.attachShadow;

Element.prototype.attachShadow = function overwrite(init: ShadowRootInit) {
    if (this.localName === 'gmp-place-autocomplete') {
        const shadow = attachShadow.call(this, {
            ...init,
            mode: 'open',
        });

        const style = document.createElement('style');
        style.textContent = `
            input {
                font-size: 16px;
            }
        `;
        shadow.appendChild(style);

        return shadow;
    }

    return attachShadow.call(this, init);
};
